import script from "./VariantMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantMenu.vue?vue&type=script&setup=true&lang=js"

import "./VariantMenu.vue?vue&type=style&index=0&id=f23c7bbe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23c7bbe"]])

export default __exports__